import moment from 'moment'
import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

export class LineUpBuques {
  static getAnuncioPorFecha (fecha) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/anuncio_buque_por_fecha?r={"clave":{"fecha_anuncio": "${fecha}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getBuquesAnunciados () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_anuncio_buque`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }

  static adaptToBackend (values = {}) {
    const {
      nombreCorto,
      fechaDeArriboDesde,
      fechaDeArriboHasta,
      agencia,
      agenciaDeEstiba,
      giro,
      estado
    } = values
    return {
      fechaAnuncio: moment().format('DD/MM/YYYY HH:mm:ss'),
      nombreCorto: nombreCorto || null,
      fechaEstimadaDeArriboDesde: fechaDeArriboDesde,
      fechaEstimadaDeArriboHasta: fechaDeArriboHasta,
      agenciaMaritima: agencia || null,
      agenciaDeEstiba: agenciaDeEstiba || null,
      giro: giro || null,
      estado: estado
    }
  }

  static insertarAnuncioBuque (formValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(formValues)
    console.log('valores ', valores)
    const promise = axios.post(`anuncio_buque`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result)
  }

  static updateAnuncioBuque (fecha, formValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(formValues)
    const promise = axios.put(`anuncio_buque`, { valores: { ...valores }, clave: { fecha_anuncio: fecha } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return [result, valores.fechaAnuncio] })
  }

  static updateFechaPlanDeEmbarque (fecha, fechaDeReferencia) {
    const axios = getAxiosInstance()
    const valores = fechaDeReferencia || null
    const promise = axios.put(`anuncio_buque`, { valores: { fecha_plan_de_embarque: valores }, clave: { fecha_anuncio: fecha } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static deleteAnuncioBuque (fecha) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`anuncio_buque?r=` +
      `{"clave":{"fecha_anuncio": "${fecha}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static cancelarAnuncioBuque (fecha, estado) {
    const axios = getAxiosInstance()
    const fechaActualizacion = moment().format('DD/MM/YYYY HH:mm:ss')
    const promise = axios.put(`anuncio_buque`, { valores: { estado: estado, fecha_anuncio: fechaActualizacion, fecha_plan_de_embarque: null }, clave: { fecha_anuncio: fecha } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateFechaDeCarga (fecha, fechaD, fechaH) {
    const axios = getAxiosInstance()
    const promise = axios.put(`anuncio_buque`, { valores: { fecha_inicio_carga: fechaD, fecha_fin_carga: fechaH }, clave: { fecha_anuncio: fecha } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }
}
